import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { SimpleModal, BackdropLoader } from '@livable/saas-react-components';
import { Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PrivacyPolicy from 'src/components/general/PrivacyPolicy';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const ToSModal = observer(_ref => {
  let noCancelletion = _ref.noCancelletion,
    open = _ref.open;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showRules = _useState4[0],
    setShowRules = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    termAndConditionChecked = _useState6[0],
    setTermAndConditionChecked = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    privacyPolicyChecked = _useState8[0],
    setPrivacyPolicyChecked = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    userAcknowledgmentChecked = _useState0[0],
    setUserAcknowledgmentChecked = _useState0[1];
  const handleCheck = (e, data) => {
    if (e.target.checked) {
      setShowRules(data);
    } else {
      switch (data) {
        case 'termAndCondition':
          setTermAndConditionChecked(false);
          break;
        case 'privacyPolicy':
          setPrivacyPolicyChecked(false);
          break;
        default:
          setUserAcknowledgmentChecked(false);
      }
    }
  };
  const handleAgreeClick = data => {
    switch (data) {
      case 'termAndCondition':
        setTermAndConditionChecked(true);
        break;
      case 'privacyPolicy':
        setPrivacyPolicyChecked(true);
        break;
      default:
        setUserAcknowledgmentChecked(true);
    }
    setShowRules(false);
  };
  const handleSubmit = async () => {
    await store.notifications.acknowledgementNotificationAsync.run({
      notificationId: store.notifications.currentTos.id
    });
    await store.notifications.viewNotificationAsync.run({
      notificationId: store.notifications.currentTos.id
    });
    store.notifications.resetCurrentToS();
    setIsOpen(false);
  };
  const getModalTitle = () => {
    switch (showRules) {
      case 'termAndCondition':
        return t('general.terms_and_conditions');
      case 'privacyPolicy':
        return t('general.privacy_policy');
      case 'userAcknowledgment':
        t('general.user_acknowledgment');
      default:
        return store.notifications.currentTos.title;
    }
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    disableEscapeKeyDown: true,
    handleClose: () => setIsOpen(false),
    handleOpen: () => setIsOpen(true),
    isOpen: isOpen,
    noCloseButton: noCancelletion,
    title: getModalTitle(),
    noFooter: true,
    noPadding: true,
    trigger: null
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.modalContent, " ").concat(showRules ? classes.modalContentExpanded : '')
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "div"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.textContent,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(store.notifications.currentTos.body)
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, showRules && /*#__PURE__*/React.createElement("div", {
    className: classes.rulesContainer
  }, showRules === 'termAndCondition' ? /*#__PURE__*/React.createElement(PrivacyPolicy, null) : /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, showRules === 'privacyPolicy' ? t('general.privacy_policy_body') : t('general.user_acknowledgment_body')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    fullWidth: true,
    onClick: () => handleAgreeClick(showRules),
    'custom-attribute': '401-ToSModal'
  }, showRules === 'termAndCondition' ? t('general.terms_and_conditions_accept') : showRules === 'privacyPolicy' ? t('general.privacy_policy_accept') : t('general.user_acknowledgment_accept')))), store.notifications.currentTos.termsOfConditions && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: termAndConditionChecked,
      onChange: e => handleCheck(e, 'termAndCondition'),
      'custom-attribute': '402-ToSModal'
    }),
    label: /*#__PURE__*/React.createElement("span", null, t('general.i_agree_with'), " ", /*#__PURE__*/React.createElement("span", {
      className: classes.link
    }, t('general.terms_and_conditions')))
  }), store.notifications.currentTos.privacyPolicy && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: privacyPolicyChecked,
      onChange: e => handleCheck(e, 'privacyPolicy'),
      'custom-attribute': '403-ToSModal'
    }),
    label: /*#__PURE__*/React.createElement("span", null, t('general.i_agree_with'), " ", /*#__PURE__*/React.createElement("span", {
      className: classes.link
    }, t('general.privacy_policy')))
  }), store.notifications.currentTos.userAcknowledgement && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: userAcknowledgmentChecked,
      onChange: e => handleCheck(e, 'userAcknowledgment'),
      'custom-attribute': '404-ToSModal'
    }),
    label: /*#__PURE__*/React.createElement("span", null, t('general.i_agree_with'), " ", /*#__PURE__*/React.createElement("span", {
      className: classes.link
    }, t('general.user_acknowledgment')))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, showRules && /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => setShowRules(false),
    'custom-attribute': '405-ToSModal'
  }, t('buttons.cancel')), !showRules && /*#__PURE__*/React.createElement(Button, {
    disabled: store.notifications.currentTos.termsOfConditions && !termAndConditionChecked || store.notifications.currentTos.privacyPolicy && !privacyPolicyChecked || store.notifications.currentTos.userAcknowledgement && !userAcknowledgmentChecked,
    onClick: handleSubmit,
    variant: "priority",
    type: "submit",
    'custom-attribute': '406-ToSModal'
  }, "Complete")), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.notifications.viewNotificationAsync.inProgress || store.notifications.acknowledgementNotificationAsync.inProgress
  }));
});